import { Option } from 'app/model/dropdown/dropdown-option-model';

export enum DialogMyProfileActionType {
  UPDATED,
  CANCEL
}

export class ProfileAdaptor {
  birthDate: String;
  fullName: String;
  email: String;
  position: String;
  year: String;
  month: String;
  date: String;
  companyName: String;
  contactNumber: String;
  countryCallingCode: String;
  countryISO2?: String;
  timeOfBirth?: String
}

export const TimeOfBirthType = {
  UN_SPECIFIED: 'unspecified',
  DAY: 'day',
  NIGHT: 'night',
}



// WEBPACK FOOTER //
// ./src/app/pages/my-profile/dialog-my-profile/dialog-my-profile.model.ts